import Icon from '../Icon.vue'

Icon.register({
  'twitter': {
    width: 16,
    height: 13,
    paths: [
      {
        d: 'M14.355 3.19c.01.14.01.28.01.42 0 4.27-3.299 9.19-9.33 9.19A9.37 9.37 0 010 11.35c.264.03.518.04.792.04 1.533 0 2.944-.51 4.071-1.38-1.442-.03-2.65-.96-3.066-2.24.203.03.406.05.62.05.294 0 .588-.04.862-.11C1.777 7.41.65 6.11.65 4.54V4.5c.437.24.945.39 1.483.41A3.215 3.215 0 01.67 2.22c0-.6.162-1.15.447-1.63a9.369 9.369 0 006.761 3.38c-.05-.24-.081-.49-.081-.74 0-1.78 1.462-3.23 3.28-3.23.943 0 1.796.39 2.395 1.02a6.516 6.516 0 002.081-.78 3.23 3.23 0 01-1.441 1.78c.66-.07 1.3-.25 1.888-.5a6.992 6.992 0 01-1.645 1.67z'
      }
    ]
  }
})
